import React from 'react';
import { ErrorFallback } from './ErrorFallback';

type ErrorBoundaryProps = {
    children: React.ReactNode;
    'data-testid': string;
    fillSpace?: boolean;
    fallbackMessage: string;
    id: string;
    onRetry?: () => void;
    retryLabel?: string;
    title: string;
};

type ErrorBoundaryState = {
    error: Error | null;
};

export class ErrorBoundary extends React.Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    public override state: ErrorBoundaryState = {
        error: null,
    };

    public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { error };
    }

    private handleRetry = () => {
        this.setState({ error: null });
        this.props.onRetry?.();
    };

    public override render() {
        if (this.state.error) {
            return (
                <ErrorFallback
                    data-testid={`${this.props.id}-fallback`}
                    error={this.state.error}
                    fillSpace={this.props.fillSpace}
                    id={`${this.props.id}-fallback`}
                    message={this.props.fallbackMessage}
                    onRetry={
                        this.props.onRetry || this.props.retryLabel
                            ? this.handleRetry
                            : undefined
                    }
                    retryLabel={this.props.retryLabel}
                    title={this.props.title}
                />
            );
        }

        return this.props.children;
    }
}
